'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Important: In addition to being compiled as part of the main client/snippet, this file is
 *   separately compiled as a standalone module so that it can be imported safely in a Node
 *   runtime. This is necessary because our server-side app needs to access the list of query
 *   parameters used by the tracking library, in order to preserve them when issuing internal
 *   redirects.
 *
 * This file should not import anything, or contain any browser-reliant code.
 *
 * See `components/Redirect` in the the Consumer app, for context.
 */
(function (TrackingQueryParameter) {
    TrackingQueryParameter["ad_id"] = "ad_id";
    TrackingQueryParameter["ad_type"] = "ad_type";
    TrackingQueryParameter["ad_search_query"] = "ad_search_query";
    TrackingQueryParameter["adgroup_id"] = "adgroup_id";
    TrackingQueryParameter["expert_id"] = "expert_id";
    TrackingQueryParameter["campaign_id"] = "campaign_id";
    TrackingQueryParameter["department"] = "department";
    TrackingQueryParameter["gclid"] = "gclid";
    TrackingQueryParameter["fbclid"] = "fbclid";
    TrackingQueryParameter["product_id"] = "product_id";
    TrackingQueryParameter["referrer_id"] = "referrer_id";
    TrackingQueryParameter["target_id"] = "target_id";
    TrackingQueryParameter["c_adgroup"] = "c_adgroup";
    TrackingQueryParameter["c_medium"] = "c_medium";
    TrackingQueryParameter["c_campaign"] = "c_campaign";
    TrackingQueryParameter["c_term"] = "c_term";
    TrackingQueryParameter["c_content"] = "c_content";
    TrackingQueryParameter["c_source"] = "c_source";
    TrackingQueryParameter["c_id"] = "c_id";
    TrackingQueryParameter["utm_adgroup"] = "utm_adgroup";
    TrackingQueryParameter["utm_medium"] = "utm_medium";
    TrackingQueryParameter["utm_campaign"] = "utm_campaign";
    TrackingQueryParameter["utm_term"] = "utm_term";
    TrackingQueryParameter["utm_content"] = "utm_content";
    TrackingQueryParameter["utm_source"] = "utm_source";
    TrackingQueryParameter["utm_id"] = "utm_id";
    TrackingQueryParameter["vt_match_type"] = "vt_match_type";
    TrackingQueryParameter["vt_device"] = "vt_device";
    TrackingQueryParameter["vt_device_model"] = "vt_device_model";
    TrackingQueryParameter["vt_geo_location"] = "vt_geo_location";
    TrackingQueryParameter["vt_interest_location"] = "vt_interest_location";
    TrackingQueryParameter["vt_placement"] = "vt_placement";
    TrackingQueryParameter["vt_target_id"] = "vt_target_id";
    TrackingQueryParameter["vt_ad_position"] = "vt_ad_position";
    TrackingQueryParameter["vt_network"] = "vt_network";
})(exports.TrackingQueryParameter || (exports.TrackingQueryParameter = {}));
(function (ViewerContext) {
    ViewerContext[ViewerContext["Consumer"] = 0] = "Consumer";
    ViewerContext[ViewerContext["BusinessUser"] = 1] = "BusinessUser";
    ViewerContext[ViewerContext["Operator"] = 2] = "Operator";
    ViewerContext[ViewerContext["PartnerUser"] = 3] = "PartnerUser";
})(exports.ViewerContext || (exports.ViewerContext = {}));
